import { MdEmail, MdLanguage } from "react-icons/md";
import { FaUserCircle ,FaWhatsapp,FaPhoneAlt ,FaSnapchatSquare  } from "react-icons/fa";
import { FaSquareInstagram,FaLocationDot } from "react-icons/fa6";
import { GrCatalog } from "react-icons/gr";
import { AiFillTikTok } from "react-icons/ai";
import { useEffect, useState } from "react";
import "../style/userCardStyle.css";
import {message} from 'antd';
import { Link } from "react-router-dom";

function BussinesCard({userCard,translate}) {
  const [photo, setPhoto] = useState("");
  useEffect(() => {
    if (userCard.cardImage) {
      getBase64Image(userCard.cardImage).then((b64) => {
        setPhoto(b64);
      });
    }
  }, [userCard]);
  // getBase64 form Image
  const getBase64Image = async (url) => {
    try {
      const res = await fetch(url, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
      });

      if (!res.ok) throw new Error("Image download failed");

      const blob = await res.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(",")[1]);
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  const generateVCF = (userCard) => {
    const photoSection =
      photo && photo !== "" ? `PHOTO;TYPE=JPEG;ENCODING=b:${photo}` : "";
    const fullName = `${userCard.name} ${userCard.ar_name}`;

    return `BEGIN:VCARD
VERSION:3.0
PRODID:-//Infotech Cards//NONSGML v1.0//EN
FN;CHARSET=UTF-8:${fullName}
N;CHARSET=UTF-8:;${fullName};;;
ORG;CHARSET=UTF-8:${userCard.company || ""}
TITLE;CHARSET=UTF-8:${userCard.job} | ${userCard.ar_job}
TEL;TYPE=CELL,VOICE:${userCard.phone1}
EMAIL;TYPE=INTERNET,WORK:${userCard.email || ""}
URL;TYPE=WORK:${userCard.website_url || ""}
item1.URL:${userCard.map_url || ""}
item1.X-ABLabel:LOCATION
${photoSection}
END:VCARD`;
  };
 
const downloadVCF = (userCard) => {
  try {
    // 1. generate VCF
    const vcfData = generateVCF(userCard);
    
    if (!vcfData) {
      throw new Error("No data generated");
    }

    const blob = new Blob([vcfData], { type: "text/vcard;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    const timestamp = Date.now();
    const fileName = `${userCard.name}_${timestamp}.vcf`;
    
    a.download = fileName;
    a.style.display = 'none';
    document.body.appendChild(a);

    a.click();

    setTimeout(() => {
      if (document.body.contains(a)) {
        document.body.removeChild(a);
      }
      // success status
      window.URL.revokeObjectURL(url);
      message.success(translate('HEADING.SAVECONNECTSUCCESSFULL'),3);
    }, 1000);

  } catch (error) {
    //(Error State)
    console.error("VCF Error:", error);
    
    message.error(translate('HEADING.SAVECONNECTFAILED'),3);
  }
};
  return (
    <div className="bussines_card">
          <div className="card_box">
            <div className="protfolie_icon">
              {userCard.cardImage === "" ? (
                <FaUserCircle />
              ) : (
                <img src={userCard.cardImage} alt="avater" />
              )}
            </div>
            <div className="name">
              <h5> {userCard.name}</h5>
              <h5>{userCard.ar_name}</h5>
            </div>
            <p>{userCard.description}</p>
            <p>{userCard.ar_description}</p>
            <ul>
              <li>
                <FaPhoneAlt /> <span> {userCard.phone1} </span>
              </li>
              {userCard.phone2 ? (
                <li>
                  <FaPhoneAlt color="#006266" />{" "}
                  <span> {userCard.phone2} </span>
                </li>
              ) : (
                ""
              )}
              {userCard.whatsapp ? (
                <li>
                  <FaWhatsapp color="#38cb7a" />{" "}
                  <Link to={`https://wa.me/${userCard.whatsapp}`} target="_blank"
                  style={{textDecoration:"none", marginTop:2}}
                  > {userCard.whatsapp} </Link>
                </li>
              ) : (
                ""
              )}
              {userCard.email ? (
                <li>
                  <MdEmail style={{ color: "#ee5253" }} />
                  <span className="email"> {userCard.email} </span>{" "}
                </li>
              ) : (
                ""
              )}
              {userCard.website_url ? (
                <li>
                  {" "}
                  <MdLanguage style={{ color: "#222f3e" }} />{" "}
                  <Link className="website" to={userCard.website_url} target="_blank" style={{textDecoration:"none", marginTop:2}}>
                    {userCard.website_url}
                  </Link>
                </li>
              ) : (
                ""
              )}
              {userCard.tiktok_url ? (
                <li>
                  {" "}
                  <AiFillTikTok />{" "}
                  <Link to={userCard.tiktok_url} target="_blank" style={{textDecoration:"none",fontSize:8,fontWeight:"bold"}}>
                    {userCard.tiktok_url}
                  </Link>
                </li>
              ) : (
                ""
              )}
                {userCard.instagram_url ? (
                <li>
                  {" "}
                  <FaSquareInstagram style={{ color: "#ff6b81" }} />{" "}
                  <Link to={userCard.instagram_url} target="_blank" style={{textDecoration:"none",fontSize:8,fontWeight:"bold", marginTop:2}}>
                    {userCard.instagram_url}
                  </Link>
                </li>
              ) : (
                ""
              )}
              {userCard.snapChat_url ? (
                <li>
                  {" "}
                  <FaSnapchatSquare style={{ color: "#222f3e" }} />{" "}
                  <Link to={userCard.snapChat_url} target="_blank" style={{textDecoration:"none",fontSize:8,fontWeight:"bold", marginTop:2}}>
                    {userCard.snapChat_url}
                  </Link>
                </li>
              ) : (
                ""
              )}
              {userCard.catalog_url ? (
                <li>
                  {" "}
                  <GrCatalog style={{ color: "#222f3e" }} />{" "}
                  <Link to={userCard.catalog_url} target="_blank" style={{textDecoration:"none", fontSize:12,fontWeight:"bold",marginTop:2}}>
                    {userCard.catalog_url}
                  </Link>
                </li>
              ) : (
                ""
              )}
                {userCard.map_url ? (
                <li>
                  {" "}
                  <FaLocationDot style={{ color: "#e74c3c" }} />{" "}
                  <Link to={userCard.map_url} target="_blank" style={{textDecoration:"none", fontSize:10,fontWeight:"bold",marginTop:2}}>
                    {userCard.map_url}
                  </Link>
                </li>
              ) : (
                ""
              )}
            </ul>
            <button onClick={() => downloadVCF(userCard)}>
              {" "}
              {translate("BUTTONS.SAVECONTACT")}{" "}
            </button>
          </div>
    </div>
  );
}

export default BussinesCard;
